import { globalDomainId } from "@lyfegen-platform/graphql-schema/models";
import { GetUserDomainsTreeQuery } from "../../../user/organization-settings/types/queries.generated";

export const sortOrganizationDomains = <T extends { id: string; name: string }>(domains?: T[]): T[] => {
	if (!domains) return [];

	return domains.sort((a, b) => {
		if (a.id === globalDomainId) return -1;
		if (b.id === globalDomainId) return 1;
		return a.name.localeCompare(b.name);
	});
};

export const sortOrganizationDomainsLabel = <T extends { value: string; label: string }>(domains?: T[]): T[] => {
	if (!domains) return [];

	return domains.sort((a, b) => {
		if (a.value === globalDomainId) return -1;
		if (b.value === globalDomainId) return 1;
		return a.label.localeCompare(b.label);
	});
};

const sortByName = (a: { name: string }, b: { name: any }) => a.name.localeCompare(b.name);

export const sortSameLevelDomains = (
	domains: GetUserDomainsTreeQuery["GetUserDomainsTree"]
): GetUserDomainsTreeQuery["GetUserDomainsTree"] => {
	return domains
		?.slice()
		.sort(sortByName)
		.map((domain) => ({
			...domain,
			children: domain.children ? sortSameLevelDomains(domain.children as GetUserDomainsTreeQuery["GetUserDomainsTree"]) : [],
		}));
};
